import { Injectable, inject } from '@angular/core'
import { TokenRepositoryService } from './token-repository.service'

@Injectable({ providedIn: 'root' })
export class TokenService {
  private tokenRepositoryService: TokenRepositoryService = inject(TokenRepositoryService)

  public setToken(token: string): void {
    this.tokenRepositoryService.setToken(token)
  }

  public setRefreshToken(refreshToken: string): void {
    this.tokenRepositoryService.setRefreshToken(refreshToken)
  }

  public setExpirationToken(expirationToken: string): void {
    this.tokenRepositoryService.setExpirationToken(expirationToken)
  }

  public setRefreshTokenExpirationTime(refreshTokenExpirationTime: string): void {
    this.tokenRepositoryService.setRefreshTokenExpirationTime(refreshTokenExpirationTime)
  }

  public getToken(): string {
    return this.tokenRepositoryService.getToken()
  }

  public getRefreshToken(): string {
    return this.tokenRepositoryService.getRefreshToken()
  }

  public getExpirationToken(): Date {
    return this.tokenRepositoryService.getExpirationToken()
  }

  public getRefreshTokenExpirationTime(): Date {
    return this.tokenRepositoryService.getRefreshTokenExpirationTime()
  }

  public hasToken(): boolean {
    return !!this.getToken()
  }

  public isAccessTokenExpiring(thresholdMinutes: number = 5): boolean {
    const expiration = this.getExpirationToken()
    const now = new Date()
    const diffMs = expiration.getTime() - now.getTime()
    const diffMinutes = Math.floor(diffMs / (1000 * 60))
    return diffMinutes <= thresholdMinutes
  }

  public isRefreshTokenExpired(): boolean {
    const expiration = this.getRefreshTokenExpirationTime()
    const now = new Date()
    return now >= expiration
  }
}
